import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { ResourceService } from './resource.service';
import { Observable } from 'rxjs';
import { GlobalSettings } from '../model/settings.model';
import { AuthenticationService } from './auth.service';
import { TypePolicyModel } from '../model/typePolicy.model';

@Injectable({
    providedIn: 'root'
  })
  export class TypePolicyService extends ResourceService<TypePolicyModel> {

    constructor(
        http: HttpClient, 
        settings: GlobalSettings, 
        authService: AuthenticationService) {
          super(http, "policies/TypePolicy", settings.politicasUrl, authService)
      }

      list(): Observable<Array<TypePolicyModel>> {
        return this.get();
      }

      read(id : string): Observable<Array<TypePolicyModel>> {
        return this.getBy(id).pipe(tap(console.log));
      }

  }
